import {
  Modal,
  Box,
  IconButton,
  Paper,
  useMediaQuery,
  useTheme,
  Fade,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import LoadingBackdrop from "./LoadingBackdrop";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  hideCloseBootom?: boolean;
  loading?: boolean;
};

export default function ModalGeneric({
  open,
  onClose,
  children,
  style,
  hideCloseBootom,
  loading,
}: ModalProps) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2, // padding horizontal para responsividade
      }}
    >
      <Fade in={open}>
        <Paper
          elevation={6}
          sx={{
            width: fullScreen ? "100%" : "min(90vw, 700px)",
            maxHeight: "90vh",
            position: "relative",
            borderRadius: 3,
            pt: hideCloseBootom ? 2 : 6,
            pb: 3,
            px: 3,
            overflowY: "auto",
            ...style,
          }}
        >
          {loading && <LoadingBackdrop open={loading} />}

          {!hideCloseBootom && (
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 10,
              }}
            >
              <CloseIcon />
            </IconButton>
          )}

          <Box id="modal-description">{children}</Box>
        </Paper>
      </Fade>
    </Modal>
  );
}
